import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";

/**
 * ScrollProgress — minimal, elegant cinematic top-line.
 * 2px tall, full Future Football™ neon spectrum (red → pink → purple → cyan).
 * Smoothly springs as the page scrolls, reinforcing flow and premium polish
 * without adding any UI clutter.
 */
const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 110,
    damping: 28,
    mass: 0.25,
    restDelta: 0.001,
  });

  return (
    <motion.div
      data-testid="scroll-progress"
      aria-hidden
      className="pointer-events-none fixed inset-x-0 top-0 z-[60] h-[2px] origin-left"
      style={{
        scaleX,
        background:
          "linear-gradient(90deg, #FF2D5C 0%, #FF3DCB 30%, #9B4DFF 60%, #3DBFFF 90%, #6FF6FF 100%)",
        boxShadow:
          "0 0 8px rgba(255,61,203,0.55), 0 0 18px rgba(155,77,255,0.4), 0 0 28px rgba(61,191,255,0.3)",
      }}
    />
  );
};

export default ScrollProgress;
